export enum PermissionsPickerVariant {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum PermissionResourceType {
  LAYER = 'layer',
  FILE = 'File',
  FOLDER = 'Folder',
}
